
import { ExternalLink, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface SchoolActionButtonsProps {
  website?: string;
  onMapClick: () => void;
}

export const SchoolActionButtons = ({ website, onMapClick }: SchoolActionButtonsProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 mt-6">
      {website && (
        <Button
          variant="outline"
          className="flex-1 flex items-center justify-center space-x-2 border-primary/80 text-primary hover:bg-primary/5"
          onClick={() => window.open(website, '_blank')}
        >
          <ExternalLink className="h-4 w-4" />
          <span>{t('website')}</span>
        </Button>
      )}
      
      <Button
        className="flex-1 flex items-center justify-center space-x-2 bg-primary hover:bg-primary/90 text-white"
        onClick={onMapClick}
      >
        <MapPin className="h-4 w-4" />
        <span>Auf der Karte anzeigen</span>
      </Button>
    </div>
  );
};
